import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  Box,
} from '@mui/material';

const TYPES = ['announcement', 'alert', 'event', 'promotion'];

const AnnouncementDialog = ({ open, onClose, onSave, announcement, t }) => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [type, setType] = useState('announcement');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    if (announcement) {
      setTitle(announcement.title || '');
      setContent(announcement.content || '');
      setType(announcement.type || 'announcement');
      setEndDate(announcement.end_date ? announcement.end_date.split('T')[0] : '');
    } else {
      setTitle('');
      setContent('');
      setType('announcement');
      setEndDate('');
    }
  }, [announcement, open]);

  const handleSave = () => {
    if (!title.trim() || !content.trim()) return;
    onSave({
      title: title.trim(),
      content: content.trim(),
      type,
      end_date: endDate || null,
    });
    setTitle('');
    setContent('');
    setType('announcement');
    setEndDate('');
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {announcement
          ? t('dashboard.editAnnouncement')
          : t('dashboard.createAnnouncement')}
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          label={t('dashboard.announcementTitle')}
          fullWidth
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          sx={{ mt: 1, mb: 2 }}
        />
        <TextField
          label={t('dashboard.announcementContent')}
          fullWidth
          multiline
          rows={4}
          value={content}
          onChange={(e) => setContent(e.target.value)}
          sx={{ mb: 2 }}
        />
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField
            select
            label={t('dashboard.announcementType')}
            value={type}
            onChange={(e) => setType(e.target.value)}
            sx={{ flex: 1 }}
          >
            {TYPES.map((t_) => (
              <MenuItem key={t_} value={t_}>
                {t(`dashboard.type_${t_}`)}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            label={t('dashboard.announcementEndDate')}
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ flex: 1 }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common.cancel')}</Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={!title.trim() || !content.trim()}
        >
          {t('dashboard.announcementSave')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AnnouncementDialog;
